import { Site } from '@envato/foundation-types'
import get from 'lodash-es/get'

import threedocean from './3docean'
import audiojungle from './audiojungle'
import codecanyon from './codecanyon'
import defaults from './defaults'
import graphicriver from './graphicriver'
import photodune from './photodune'
import themeforest from './themeforest'
import videohive from './videohive'

const configs = {
  [Site.threedocean]: threedocean,
  [Site.audiojungle]: audiojungle,
  [Site.codecanyon]: codecanyon,
  [Site.graphicriver]: graphicriver,
  [Site.photodune]: photodune,
  [Site.themeforest]: themeforest,
  [Site.videohive]: videohive,
  defaults
}

type TConfig = typeof configs

/**
 * Returns specific site config property value with fallback to default one
 */
export const getConfigBySite = <
  ConfigSite extends keyof TConfig,
  ConfigKey extends keyof TConfig[ConfigSite]
>(
  site: ConfigSite,
  path: ConfigKey
): TConfig[ConfigSite][ConfigKey] => {
  const siteConfigValue = get(configs[site], path)
  const defaultConfigValue = get(configs.defaults, path)

  if (typeof siteConfigValue === 'undefined') {
    return defaultConfigValue
  }

  return siteConfigValue
}

export default configs
